import { MdsItemListSkeletonRow } from "@/design-system/components/item-list/rows/MdsItemListSkeletonRow";
import { css } from "@/domains/emotion";
import {
  MdsItemListSkeletonRowData,
  MdsItemListRowType,
  MdsItemListSize,
} from "@/design-system/components/item-list/types";

/**
 * @deprecated - Use the newer MDS components instead.
 *
 * - If something doesn't exist yet, please create a new MDS component and
 *   have it reviewed by the team!
 *
 * - If something needs to hook into our `stores`, add it to the /components directory.
 *
 * - If something is a one-off; please colocate it with the component/page that
 *   needs it.
 *
 * - If you have questions, please ask in the #hub-eng-web-team Slack channel.
 */
export const MdsSkeletonItemList = () => {
  const data: MdsItemListSkeletonRowData = {
    key: "skeleton",
    type: MdsItemListRowType.Skeleton,
    size: MdsItemListSize.Large,
    payload: {},
  };

  return (
    <div className={skeletonStyles}>
      {Array.from({ length: 10 }).map((_, i) => (
        <MdsItemListSkeletonRow data={data} key={i} />
      ))}
    </div>
  );
};

const skeletonStyles = css({
  margin: `40px 10px`,
  overflowY: "hidden",
  "> span": {
    display: "block",
    margin: `20px 0`,
  },
});
